/**
 * What the account's "Fetch with API" switch (`fetchContent`) does on each
 * platform. A platform missing from here has nothing that reads the switch,
 * so it isn't offered.
 */
const EXPLANATIONS = new Map<string, string>([
    [
        'youtube',
        "Polls this channel for new videos every 30 minutes and collects comments on its videos whenever their comment count changes, on Arwen's own API key. No authorisation needed."
    ],
    [
        'tiktokad',
        "Collects this advertiser's ads, and the comments on them. Needs an authorisation."
    ],
    ['twitter', 'Collects mentions of this profile from the X API.'],
    [
        'instagram',
        "A backstop for comments the webhook missed: whenever a post's comment count changes, collects the comments on it we don't hold. Needs Fetch posts on and an authorisation."
    ]
])

/**
 * What the switch does on `platform` (a social media service short name), or
 * `undefined` where nothing reads it and the switch should be hidden.
 */
export function fetchContentExplanation(platform: string | null | undefined): string | undefined {
    return platform ? EXPLANATIONS.get(platform.toLowerCase()) : undefined
}
